import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getPayoutsBySpv } from 'src/api/stoApi';
import { Payouts } from 'src/models';
import { PayoutStatus } from 'src/models/enum';
import { generalStore } from 'src/stores/GeneralStore';

export const usePayoutBySpv = (spvs: string[] | null, status: PayoutStatus[]) => {
  const [payouts, setPayouts] = useState<Payouts | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!spvs) return;
        const response = (await getPayoutsBySpv(spvs, status)).data;
        setPayouts(response.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (!spvs) return;
    load();
  }, [spvs?.length]);

  return payouts;
};
